import * as tslib_1 from "tslib";
import { EventBase } from "../events/EventBase";
var TimerEvent = (function (_super) {
    tslib_1.__extends(TimerEvent, _super);
    function TimerEvent(type) {
        return _super.call(this, type) || this;
    }
    return TimerEvent;
}(EventBase));
export { TimerEvent };
/**
 *
 */
TimerEvent.TIMER = "timer";
/**
 *
 */
TimerEvent.TIMER_COMPLETE = "timerComplete";
export default TimerEvent;



// WEBPACK FOOTER //
// ../dist/lib/events/TimerEvent.js